import { useEffect, useRef, useState } from 'react';

import {
	Chart as ChartJS,
	CategoryScale,
	Tooltip,
	Title,
	Legend,
} from 'chart.js';
import * as ChartGeo from 'chartjs-chart-geo';
import _ from 'lodash';
import { Chart } from 'react-chartjs-2';

import MAP_JSON from '../../../common/constants/GeoMapConstants';

import styles from './Overview.module.scss';

const { whiteText } = styles;

ChartJS.register(
	Title,
	Tooltip,
	Legend,
	CategoryScale,
	ChartGeo.ChoroplethController,
	ChartGeo.ProjectionScale,
	ChartGeo.ColorScale,
	ChartGeo.GeoFeature,
);

const GeoMap = (props: { chosenKey: keyof typeof MAP_JSON }) => {
	const chartRef = useRef();
	const [sdata, setData] = useState<any>([]);

	useEffect(() => {
		fetch(MAP_JSON[props?.chosenKey].url)
			.then((response) => response.json())
			.then((value) => {
				setData(
					ChartGeo.topojson.feature(
						value,
						value.objects[MAP_JSON[props?.chosenKey].objectsKey],
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
					).features,
				);
			});
	}, [props?.chosenKey]);

	return (
		<Chart
			ref={chartRef}
			type="choropleth"
			data={{
				labels: sdata.map(
					(d: any) => d.properties[MAP_JSON[props?.chosenKey].propertiesKey],
				),
				datasets: [
					{
						outline: sdata,
						label: 'Countries',
						data: sdata.map((d: any) => ({
							feature: d,
							value: _.random(0, 1, true),
						})),
					},
				],
			}}
			options={{
				showOutline: false,
				showGraticule: false,
				plugins: {
					legend: {
						display: false,
					},
				},

				scales: {
					projection: {
						axis: 'x',
						projection: 'equalEarth',
						grid: {
							display: false,
							color: whiteText,
						},
					},
				},
				// scales: {
				//   xy: {
				//     // projection: 'equalEarth'
				//   },
				//   x: {
				//     display: false,

				//     grid: {
				//       display: false,
				//       color: 'white'
				//     },
				//     ticks: {
				//       display: false
				//     }
				//   },
				//   y: {
				//     display: false,

				//     grid: {
				//       color: 'white',
				//       display: false
				//     },
				//     ticks: {
				//       display: false
				//     }
				//   }
				//   // Hide color scale
				//   // color: {
				//   //   display: false
				//   // }
				// }
			}}
		/>
	);
};

export default GeoMap;
